export default {
  heroEyebrow: 'Тарифы',
  heroTitle: 'Начните с одного процесса и масштабируйте',
  heroBody:
    'Free и Team — для самостоятельного старта. Enterprise — для внедрения в корпоративном масштабе и поставки в нужном контуре.',

  billingYearly: 'За год',
  billingYearlySave: 'скидка 13%',
  billingMonthly: 'Помесячно',

  tierBusinessName: 'Бизнес',
  tierBusinessAudience: 'Free для проверки',
  tierBusinessCta: 'Начать бесплатно',
  tierBusinessFeature1: 'Настраиваемые цифровые сотрудники',
  tierBusinessFeature2: 'Запуски по расписанию и история результатов',
  tierBusinessFeature3:
    'Jira, Confluence, GitHub, документы, почта и календари',
  tierBusinessFeature4: 'Ответы со ссылками на источники',
  tierBusinessFeature5: 'Права доступа подключённых систем',
  tierBusinessFeature6: 'Cloud и поддержка по почте',

  planFreeName: 'Free',
  planFreeSeats: '14 дней · 1 пользователь',
  planFreePrice: '0 ₽',
  planTeamName: 'Team',
  planTeamSeats: 'за пользователя в месяц',
  planTeamPriceMonthly: '2 300 ₽',
  planTeamPriceYearly: '1 990 ₽',

  tierEnterpriseName: 'Энтерпрайз',
  tierEnterpriseAudience: 'Для AI-команд и корпоративного масштаба',
  tierEnterpriseCta: 'Запросить демо',
  tierEnterprisePlusLabel: 'В Enterprise входит:',
  tierEnterpriseFeature1: 'Cloud, Hybrid или On-Premises',
  tierEnterpriseFeature2: 'Кастомные плагины и интеграции',
  tierEnterpriseFeature3:
    'Подтверждение корпоративного домена как альтернатива SSO',
  tierEnterpriseFeature4: 'Журнал действий и governance',
  tierEnterpriseFeature5: 'Масштабирование на подразделения и процессы',
  tierEnterpriseFeature6: 'Выделенное сопровождение на всех этапах и SLA',

  deliveryEyebrow: 'Варианты поставки',
  deliveryTitle: 'Выберите подходящий контур',
  deliveryBody:
    'Laplace поставляется в Cloud, Hybrid и On-Premises. Архитектуру, доступ к данным и зоны ответственности фиксируем до запуска.',
  deliveryCloudTitle: 'Cloud',
  deliveryCloudBody:
    'Управляемый сервис с быстрым запуском и обновлениями. Подтверждение корпоративного домена доступно как альтернатива SSO.',
  deliveryOnPremTitle: 'On-Premises',
  deliveryOnPremBody:
    'Развёртывание Laplace в инфраструктуре заказчика для закрытого корпоративного контура.',
  deliveryHybridTitle: 'Hybrid',
  deliveryHybridBody:
    'Облачный Laplace с Private Connector: доступ к Jira, Confluence и GitHub выполняется внутри сети заказчика.',

  matrixTitle: 'Что входит в тарифы',
  matrixColFeatures: 'Возможности',
  matrixYes: 'Включено',
  matrixNo: 'Недоступно',
  matrixRowUsers: 'Пользователи',
  matrixRowUsersBusiness: 'Free — 1, Team — до 20',
  matrixRowUsersEnterprise: 'по согласованию',
  matrixRowWorkspaces: 'Workspace',
  matrixRowWorkspacesBusiness: 'Free — 3, Team — без ограничений',
  matrixRowWorkspacesEnterprise: 'по согласованию',
  matrixRowIntegrations: 'Интеграции',
  matrixRowIntegrationsBusiness: 'стандартные',
  matrixRowIntegrationsEnterprise: 'стандартные + кастомные',
  matrixRowCloud: 'Cloud',
  matrixRowOnPrem: 'On-Premises',
  matrixRowHybrid: 'Hybrid',
  matrixRowCorporateDomain: 'Подтверждение корпоративного домена',
  matrixRowAudit: 'Context Audit',
  matrixRowSupport: 'Поддержка',
  matrixRowSupportBusiness: 'по почте',
  matrixRowSupportEnterprise: 'сопровождение + SLA',
  matrixFootnote:
    'Cloud и Hybrid доступны для всех тарифов. On-Premises поставляется в рамках Enterprise по согласованной архитектуре.',

  ctaTitle: 'Подберём формат под ваш первый процесс',
  ctaBody:
    'На демо разберём сценарий, подходящий контур и критерии результата, затем предложим подходящую конфигурацию Laplace.',
  ctaButton: 'Запросить демо',
}
